import { render } from "./AppStore.vue?vue&type=template&id=aff9d450"
import script from "./AppStore.vue?vue&type=script&lang=js"
export * from "./AppStore.vue?vue&type=script&lang=js"

import "./AppStore.vue?vue&type=style&index=0&id=aff9d450&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__